import useCarFactoryDelete from 'api/carFactory/useCarFactoryDelete/useCarFactoryDelete';
import useCarFactoryList from 'api/carFactory/useCarFactoryList/useCarFactoryList';
import DeleteModal from 'components/shared/DeleteModal/DeleteModal';
import CarFactoryEditModal from 'components/shared/Modals/carFactory/CarFactoryEditModal/CarFactoryEditModal';
import CarFactoryInsertModal from 'components/shared/Modals/carFactory/CarFactoryInsertModal/CarFactoryInsertModal';
import ApiPaginateTable from 'components/shared/Table/ApiPaginateTable';
import useCarFactoryTableColumns from 'hooks/carFactory/useCarFactoryTableColumns';
import { permissions } from 'hooks/permissions/permissions';
import { usePermissions } from 'hooks/permissions/usePermissions';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import PageSpinner from '../../components/shared/pageSpinner/PageSpinner';

// last search string
let lastSearch = null;

const CarFactory = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState('100');
  const [getCarFactoryList, loading, carFactoryList, pageRef] =
    useCarFactoryList();

  const [isInsertModalOpen, setIsInsertModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteChosenLocation, setDeleteChosenLocation] = useState({});
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editChosenCode, setEditChosenCode] = useState({});

  const tableRef = useRef(null);

  const [deleteRequest] = useCarFactoryDelete();

  const navigate = useNavigate();
  const { can } = usePermissions();

  const carFactoryPermissions =
    permissions.general.categories.globalSettings.coddingSettings.carFactory;

  const canCreate = can(carFactoryPermissions.create);
  const canEdit = can(carFactoryPermissions.edit);
  const canDelete = can(carFactoryPermissions.delete);
  const canDetail = can(carFactoryPermissions.brands.view);

  useEffect(() => {
    getCarFactoryList({ page: 1, count: pageSize });
  }, []);

  useEffect(() => {
    getCarFactoryList({ page, count: pageSize });
  }, [pageSize]);

  const goToInfoPage = useCallback(
    row => () => navigate(`/carBrand/${row.id}`),
    [],
  );

  const deleteItem = useCallback(
    row => () => {
      setDeleteChosenLocation(row);
      setIsDeleteModalOpen(true);
    },
    [],
  );

  const editItem = useCallback(
    row => () => {
      setEditChosenCode(row);
      setIsEditModalOpen(true);
    },
    [],
  );

  const [columnsData] = useCarFactoryTableColumns(
    goToInfoPage,
    deleteItem,
    editItem,
    tableRef,
    {
      canDetail,
      canEdit,
      canDelete,
    },
  );

  const deleteHandle = id => {
    setDeleteLoading(true);
    deleteRequest(
      id,
      getCarFactoryList,
      setIsDeleteModalOpen,
      setDeleteLoading,
    );
  };

  function getPageData(pageNumber) {
    setPage(pageNumber);
    getCarFactoryList({ page: pageNumber, count: pageSize, term: lastSearch });
  }

  function handleSearch(text) {
    setPage(1);
    lastSearch = text;
    if (text === '') {
      lastSearch = null;
    }
    getCarFactoryList({ page: 1, count: pageSize, term: text });
  }

  return (
    <>
      <div>{pageRef.refTitle}</div>

      {Object.keys(carFactoryList).length !== 0 ? (
        <ApiPaginateTable
          columns={columnsData}
          rowsData={carFactoryList[page]}
          rows={carFactoryList[page]}
          pageSize={pageSize}
          isDeletable={canDelete}
          isLoading={loading}
          addLable={canCreate ? 'ثبت کارخانه خودرو' : undefined}
          onAddClick={canCreate ? () => setIsInsertModalOpen(true) : undefined}
          setPageSize={val => setPageSize(val)}
          apiRef={tableRef}
          onPageChange={p => getPageData(p)}
          page={page}
          countPages={
            pageRef?.totalCount ? Math.ceil(pageRef.totalCount / pageSize) : 1
          }
          handleSearchApi={handleSearch}
        />
      ) : (
        <PageSpinner loading />
      )}

      {canCreate ? (
        <CarFactoryInsertModal
          open={isInsertModalOpen}
          handleClose={() => setIsInsertModalOpen(false)}
          getCarFactoryList={getCarFactoryList}
        />
      ) : null}

      {canDelete ? (
        <DeleteModal
          open={isDeleteModalOpen}
          handleClose={() => setIsDeleteModalOpen(false)}
          title={deleteChosenLocation.title}
          locationId={deleteChosenLocation.id}
          deleteLoading={deleteLoading}
          onDelete={deleteHandle}
        />
      ) : null}

      {canEdit ? (
        <CarFactoryEditModal
          open={isEditModalOpen}
          handleClose={() => setIsEditModalOpen(false)}
          chosenCarFactory={editChosenCode}
          getCarFactoryList={getCarFactoryList}
        />
      ) : null}
    </>
  );
};

export default CarFactory;
